import { Component, input } from '@angular/core';

export interface UiBreadcrumbItem {
  label: string;
}

@Component({
  selector: 'ui-breadcrumbs',
  standalone: true,
  template: `
    <nav class="ui-breadcrumbs" aria-label="Breadcrumb">
      @for (item of items(); track $index; let last = $last) {
        <span [class.ui-breadcrumbs__current]="last">{{ item.label }}</span>
        @if (!last) {
          <span class="ui-breadcrumbs__sep" aria-hidden="true">/</span>
        }
      }
    </nav>
  `,
  styles: [`
    .ui-breadcrumbs {
      display: inline-flex;
      align-items: center;
      min-height: 2.25rem;
      font-size: 0.8125rem;
      color: var(--text-muted, #8c8c8c);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 12rem;
    }

    @media (width >= 48rem) {
      .ui-breadcrumbs {
        max-width: 20rem;
      }
    }

    .ui-breadcrumbs__current {
      font-weight: 600;
    }

    .ui-breadcrumbs__sep {
      margin: 0 0.25rem;
      opacity: 0.6;
    }

    :host-context(.ui-topbar--primary) .ui-breadcrumbs {
      color: var(--topbar-fg-muted, var(--on-brand-primary-muted));
    }

    :host-context(.ui-topbar--primary) .ui-breadcrumbs__current {
      color: var(--topbar-fg, var(--on-brand-primary));
    }

    :host-context(.ui-topbar--primary) .ui-breadcrumbs__sep {
      color: var(--topbar-fg-muted, var(--on-brand-primary-muted));
      opacity: 1;
    }
  `],
})
export class UiBreadcrumbsComponent {
  items = input<UiBreadcrumbItem[]>([]);
}
